import React from 'react'
import ContactPage from './Contact'

const Contact = () => (
    <ContactPage/>
)

export default Contact
